import * as React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Translate } from 'react-localize-redux';

import {
    Typography, Menu, MenuItem, IconButton, Hidden, Divider,
} from '@material-ui/core';

import {
    GridIcon, LogoutIcon, PersonIcon, ExpandIcon, CollapseIcon, RoleIcon,
} from '../../../common/icons';

import logo from '../../../common/image/logo negativ stor.svg';
import * as AuthStore from '../../../app/store/AuthStore';
import * as PageSettingStore from '../../../app/store/PageSettingStore';
import urls from '../../../app/urls';
import { Image } from '../../../youwell-common/components';

const styles = theme => ({
    root: {
        height: theme.sizes.headerHeight,
        padding: `0 ${theme.spacing(4)}px`,
        display: 'flex',
        flexShrink: 0,
        alignItems: 'center',
        color: theme.colors.grey1,
        background: theme.colors.blue4,

        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(0, 1),
        },
    },
    titleLogo: {
        flex: '1 1 auto',
        textAlign: 'center',

        [theme.breakpoints.down('xs')]: {
            textAlign: 'left',
        },
    },
    logo: {
        width: 100,
    },
    menuContainer: {
        display: 'flex',
        alignItems: 'center',

        '@media print': {
            display: 'none',
        },
    },
    iconLabelDiv: {
        display: 'flex',
        alignItems: 'center',
    },
    icon: {
        marginRight: theme.spacing(1),
    },
    dropMenu: {
        top: 40,
    },
    menuItem: {
        borderBottom: theme.borders.normal,
    },
    studentName: {
        display: 'flex',
        alignItems: 'center',
    },
    student: {
        minWidth: 150,
    },
    activeStudent: {
        background: theme.colors.grey2,
    },
    underline: {
        borderBottom: '1px solid',
    },
});

class Header extends React.Component {
    state = {
        studentMenuAnchorEl: null,
    };

    changeRole = () => {
        this.props.logoutRole();
    };

    openMenu = name => (event) => {
        this.setState({ [name]: event.currentTarget });
    };

    closeMenu = name => () => {
        this.setState({ [name]: null });
    };

    showIntroPopup = () => {
        this.closeMenu('studentMenuAnchorEl')();
        this.props.showIntroTour();
    }

    render() {
        const {
            classes, profileData, studentList, studentData, clientConfig,
        } = this.props;

        const hasMoreStudents = studentList && studentList.length > 1;

        return (
            <div className={classes.root}>
                {profileData && (
                    <Hidden implementation="css" xsDown>
                        <div className={classes.menuContainer}>
                            <GridIcon color="primary" className={classes.icon} />
                            <Typography
                                color="inherit"
                            >
                                {profileData.name}
                            </Typography>
                        </div>
                    </Hidden>
                )}

                <Link to={`${urls.inside.home}`} className={classes.titleLogo}>
                    <Image src={logo} alt="Logo" className={classes.logo} />
                </Link>

                <div className={classes.menuContainer}>

                    {studentData && (
                        <Link
                            to={`${urls.inside.student.home}/${studentData.id}`}
                            className={classes.studentName}
                        >
                            <PersonIcon color="inherit" className={classes.icon} />
                            <Typography color="inherit" className={classes.icon}>
                                <span className={classes.underline}>
                                    {studentData.name}
                                </span>
                            </Typography>
                        </Link>
                    )}

                    <IconButton
                        aria-owns={this.state.studentMenuAnchorEl ? 'student-menu' : undefined}
                        aria-haspopup="true"
                        onClick={this.openMenu('studentMenuAnchorEl')}
                    >
                        {this.state.studentMenuAnchorEl ? <CollapseIcon color="primary" /> : <ExpandIcon color="primary" />}
                    </IconButton>

                    <Menu
                        id="student-menu"
                        className={classes.dropMenu}
                        anchorEl={this.state.studentMenuAnchorEl}
                        open={Boolean(this.state.studentMenuAnchorEl)}
                        onClose={this.closeMenu('studentMenuAnchorEl')}
                    >
                        <MenuItem
                            className={classes.menuItem}
                            component={Link}
                            to={`${urls.home}`}
                            onClick={this.closeMenu('studentMenuAnchorEl')}
                        >
                            <Typography color="inherit">
                                <Translate id="header.frontPage" />
                            </Typography>
                        </MenuItem>

                        <MenuItem
                            className={classes.menuItem}
                            component={Link}
                            to={`${urls.inside.home}`}
                            onClick={this.closeMenu('studentMenuAnchorEl')}
                        >
                            <Typography color="inherit">
                                <Translate id="header.myOverview" />
                            </Typography>
                        </MenuItem>

                        {profileData?.userAccess?.editUsers && (
                            <MenuItem
                                className={classes.menuItem}
                                component={Link}
                                to={`${urls.inside.users.home}`}
                                onClick={this.closeMenu('studentMenuAnchorEl')}
                            >
                                <Typography color="inherit">
                                    <Translate id="header.users" />
                                </Typography>
                            </MenuItem>
                        )}

                        <MenuItem
                            className={classes.menuItem}
                            component={Link}
                            to={`${urls.inside.program.home}`}
                            onClick={this.closeMenu('studentMenuAnchorEl')}
                        >
                            <Typography color="inherit">
                                <Translate id="header.aboutTheProgram" />
                            </Typography>
                        </MenuItem>

                        <MenuItem
                            className={classes.menuItem}
                            onClick={this.showIntroPopup}
                        >
                            <Typography color="inherit">
                                <Translate id="header.showIntroduction" />
                            </Typography>
                        </MenuItem>

                        {hasMoreStudents && studentList.map(student => (
                            <MenuItem
                                key={student.id}
                                className={studentData && student.id === studentData.id ? classes.activeStudent : classes.student}
                                component={Link}
                                to={`${urls.inside.student.home}/${student.id}`}
                                onClick={this.closeMenu('studentMenuAnchorEl')}
                            >
                                <PersonIcon color="secondary" className={classes.icon} />
                                <Typography color="inherit">
                                    {student.name}
                                </Typography>
                            </MenuItem>
                        ))}
                        <Divider />
                        {!clientConfig.u_AnonymousOnly && (
                            <MenuItem
                                component={Link}
                                to={urls.inside.profile}
                                onClick={this.closeMenu('studentMenuAnchorEl')}
                            >
                                <PersonIcon color="primary" className={classes.icon} />
                                <Typography color="inherit">
                                    <Translate id="header.profile" />
                                </Typography>
                            </MenuItem>
                        )}
                        {profileData?.roles?.length > 1 && (
                            <MenuItem
                                component={Link}
                                to={`${urls.login}/${urls.loginParts.role}/`}
                                onClick={this.changeRole}
                            >
                                <RoleIcon color="primary" className={classes.icon} />
                                <Typography color="inherit">
                                    <Translate id="header.changeRole" />
                                </Typography>
                            </MenuItem>
                        )}
                        <MenuItem
                            component={Link}
                            to={urls.logout}
                            className={classes.iconLabelDiv}
                            onClick={this.closeMenu('studentMenuAnchorEl')}
                        >
                            <LogoutIcon color="primary" className={classes.icon} />
                            <Typography color="inherit">
                                <Translate id="header.logout" />
                            </Typography>
                        </MenuItem>
                    </Menu>
                </div>
            </div>
        );
    }
}

Header.propTypes = {
    classes: PropTypes.object.isRequired,
    profileData: PropTypes.object,
    clientConfig: PropTypes.object.isRequired,
    studentData: PropTypes.object,
    studentList: PropTypes.array,
    // studentId: PropTypes.string,
    logoutRole: PropTypes.func.isRequired,
    showIntroTour: PropTypes.func.isRequired,
};

Header.defaultProps = {
    profileData: null,
    studentList: null,
    studentData: null,
    // studentId: null,
};

const mapStateToProps = (state, ownProps) => ({
    profileData: state.auth.profileData,
    clientConfig: state.auth.clientConfig,
    studentList: state.patient.list,
    studentData: ownProps.studentId && state.patient.details && state.patient.details[ownProps.studentId],
});

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(AuthStore.actionCreators, dispatch),
    showIntroTour: bindActionCreators(PageSettingStore.actionCreators, dispatch).showIntroTour,
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withStyles(styles)(Header));
